import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import AppBar from "@mui/material/AppBar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
// import Image2 from "../../assets/banner/banner1.jpg";
import Intro from "./components/Intro";
import OurVision from "./components/OurVision";
import Commitment from "./components/Commitment";
import Principles from "./components/Principles";
import Image from "../../assets/images/objective.jpg";
import Image2 from "../../assets/banner/ai.jpg";
import Leadership from "./components/Leadership";
import Banner from "./components/Banner";
// import Board from "./components/Board";

const styles = {
  paperContainer: {
    height: 1100,
    backgroundImage: `url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const styles2 = {
  paperContainer: {
    height: 300,
    backgroundImage: `linear-gradient(rgba(57,72,78,0.5),rgba(57,72,78,0.5)), url(${Image2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const About = () => {
  return (
    <Box>
      <Helmet>
        <title>
          {" "}
          About AIR Fund | The African Innovation and Resilience Fund
        </title>
      </Helmet>
      <AppBar
        position={"sticky"}
        elevation={0}
        sx={{
          backgroundColor: "#fff",
          padding: "10px 0px",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
          <Header />
        </Container>
      </AppBar>
      <Box style={styles2.paperContainer}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box bgcolor={"#fff"}>
        <Container>
          <Intro />
        </Container>
      </Box>
      <Box display={{ xs: "none", sm: "block" }} bgcolor={"#fff"}>
        <OurVision />
      </Box>
      <Box
        display={{ xs: "block", sm: "none" }}
        style={styles.paperContainer}
        bgcolor={"#fff"}
      >
        <OurVision />
      </Box>
      <Box bgcolor={"#fff"}>
        <Container>
          <Commitment />
        </Container>
      </Box>
      <Box bgcolor={"#F6F4F0"}>
        <Container>
          <Principles />
        </Container>
      </Box>
      <Box bgcolor={"#F6F4F0"}>
        <Container>
          <Leadership />
        </Container>
      </Box>
      <Box bgcolor={"#39484E"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default About;
